import EncryptedStorage from 'react-native-encrypted-storage';
import { Platform } from 'react-native';
import type { NotifyPermissionStatus } from '../realtime/notifyIncomingMessage';

/**
 * Когда показывать карточку «Включите уведомления» (аудит удобства 2026-10-04, п. 34 и 15).
 *
 * <p>Только пока разрешение ещё не спрашивали: выданное спрашивать незачем, а на отказ
 * системное окно больше не появится — там помогает только переход в настройки, и о нём
 * говорит отдельная подсказка.
 *
 * <p>«Не сейчас» откладывает карточку на неделю, а не навсегда: человек, отмахнувшийся в первую
 * минуту, обычно ещё не знает, нужны ли ему звонки в фоне, — а без уведомлений входящий в
 * фоне на телефоне просто не услышат.
 */
export const NOTIFY_PRIMER_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

export function shouldShowNotifyPrimer(
  status: NotifyPermissionStatus,
  snoozedAtMs: number | null,
  nowMs: number,
): boolean {
  if (status !== 'undetermined') return false;
  if (snoozedAtMs === null) return true;
  return nowMs - snoozedAtMs >= NOTIFY_PRIMER_SNOOZE_MS;
}

const KEY = 'svyaz_notify_primer_snoozed_at';

/** Когда нажали «Не сейчас»; `null` — не нажимали (или хранилище недоступно). */
export async function readNotifyPrimerSnooze(): Promise<number | null> {
  try {
    const raw =
      Platform.OS === 'web' ? (globalThis.localStorage?.getItem(KEY) ?? null) : await EncryptedStorage.getItem(KEY);
    const n = raw ? Number(raw) : NaN;
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export async function writeNotifyPrimerSnooze(atMs: number): Promise<void> {
  try {
    if (Platform.OS === 'web') {
      globalThis.localStorage?.setItem(KEY, String(atMs));
      return;
    }
    await EncryptedStorage.setItem(KEY, String(atMs));
  } catch {
    /* не запомнили — карточка покажется ещё раз, это не беда */
  }
}
